import React, { Fragment, useRef, useState, useEffect } from "react";
import PropTypes from "prop-types";
import Name from "./SpecialCheck/Name";
import Phone from "./SpecialCheck/Phone";
import DataTables from "./SpecialCheck/DataTables";
import SearchIcon from "@material-ui/icons/Search";
import axios from "axios";
import Meta from "../lib/Meta";
import { url } from "../lib/Common";
import { Button } from "@material-ui/core";
import AvailablePoint from "./SpecialCheck/AvailablePoint";

function SpecialCheck({ specialCheck, onChangeName, onChangePhone }) {
  const nameRef = useRef(null);
  const phoneRef = useRef(null);
  const formRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [data, setData] = useState([]);
  const [blurFlag, setBlurFlag] = useState(false);
  let doubleSubmitFlag = false;

  useEffect(() => {
    return () => {
      if (!open) {
        // 조회 후, 오픈되었을때 뒤로가기 가능토록
        window.history.pushState(null, null, window.location.pathname);
        window.addEventListener("popstate", onBackButtonEvent);
      }
    };
  }, [open]);
  const onBackButtonEvent = (e) => {
    if (!open) {
      setOpen(false);
      setData([]);
      setBlurFlag(false);
      onChangeName("");
      nameRef.current.value = "";
      onChangePhone("");
      phoneRef.current.value = "";
      nameRef.current.focus();
    }
  };
  const pointView = async () => {
    const urlPointView = url + "/api/specialMember/SpecialPointView";
    try {
      const response = await axios.post(urlPointView, specialCheck, {
        withCredentials: true,
      });
      setData((prevData) => [...prevData, response.data]);
      setOpen((preValue) => true);
    } catch (e) {
      const userName = specialCheck.name;
      const userPhone = specialCheck.phone;
      alert(
        "이름 : " +
          userName +
          ", 휴대폰번호 : " +
          userPhone +
          " 는 회원이 아닙니다."
      );
    }
    return;
  };

  const onDoubleSubmitCheck = () => {
    if (doubleSubmitFlag) {
      return doubleSubmitFlag;
    } else {
      doubleSubmitFlag = true;
      return false;
    }
  };

  const onValidate = () => {
    if (specialCheck.name === undefined || specialCheck.name === "") {
      nameRef.current.focus();
      alert("이름 입력은 필수입니다.");
      return false;
    } else if (specialCheck.phone === undefined || specialCheck.phone === "") {
      phoneRef.current.focus();
      alert("휴대폰번호 입력은 필수입니다.");
      return false;
    }
    return true;
  };

  const onSubmitHandler = (e) => {
    e.preventDefault(); // 아무 동작 안하고 버튼만 눌러도 리프레쉬 되는 것을 막는다
    if (!blurFlag) return;
    if (onDoubleSubmitCheck()) return;
    if (onValidate() === false) return;
    pointView();
  };

  const metaData = {
    image: "%PUBLIC_URL%/logo192.png",
    title: "특판 포인트 조회",
    description: "특판 포인트 조회 페이지입니다.",
    width: 192,
    height: 192,
    canonical: "crm/specialCheck",
  };

  return (
    <Fragment>
      <Meta data={metaData} />
      {open ? (
        <Fragment>
          <AvailablePoint data={data[0][0]} />
          <hr /> <DataTables data={data[0]} />{" "}
        </Fragment>
      ) : (
        <form onSubmit={onSubmitHandler} ref={formRef}>
          <Name
            name={specialCheck.name}
            onChangeName={onChangeName}
            nameRef={nameRef}
          ></Name>
          <Phone
            blurFlag={blurFlag}
            setBlurFlag={setBlurFlag}
            phone={specialCheck.phone}
            onChangePhone={onChangePhone}
            phoneRef={phoneRef}
            formRef={formRef}
          ></Phone>
          <hr />
          <Button
            variant="contained"
            color="primary"
            size="large"
            type="submit"
            fullWidth
            startIcon={<SearchIcon />}
          >
            조회하기
          </Button>
        </form>
      )}
    </Fragment>
  );
}
SpecialCheck.propTypes = {
  specialCheck: PropTypes.shape({
    name: PropTypes.string,
    phone: PropTypes.string,
  }).isRequired,
  onChangeName: PropTypes.func.isRequired,
  onChangePhone: PropTypes.func.isRequired,
};
export default SpecialCheck;
